<template>
  <div>
    <el-table :data="tbList">
      <el-table-column property="content" label="会员">
        <template slot-scope="scope">
          {{ vipAll[scope.row.idcVipId] || "--" }}
        </template>
      </el-table-column>
      <el-table-column property="content" label="会员内容"></el-table-column>
      <el-table-column property="activeTime" label="生效时间"></el-table-column>
      <el-table-column property="expires" label="截止时间"></el-table-column>
      <el-table-column property="source" label="开通方式">
        <template slot-scope="scope">
          {{ sourceMap[scope.row.source] }}
        </template>
      </el-table-column>
      <el-table-column property="status" label="状态">
        <template slot-scope="scope">
          {{ statusMap[scope.row.status] }}
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-table
      :data="tbList"
      size="small"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column
        align="left"
        prop="vip_name"
        label="会员名称"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="idc_benefit_names"
        label="权益及使用情况"
      >
        <template slot-scope="scope">
          {{ (scope.row.idc_benefit_names || []).join("、") }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="vip_month" label="有效期">
        <template slot-scope="scope"> {{ scope.row.vip_month }} 月 </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="active_time"
        label="生效时间"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="expires"
        label="截至时间"
      ></el-table-column>
      <el-table-column align="left" prop="source" label="开通方式">
        <template slot-scope="scope">
          {{ sourceMap[scope.row.source] }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="status" label="状态" width="120">
        <template slot-scope="scope">
          {{ statusMap[scope.row.status] }}
        </template>
      </el-table-column>
    </el-table> -->
    <div class="dial-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 20, 50, 100, 200, 300, 400]"
        :page-size="size"
        layout="->,sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { userVipList } from "../../../api/userApi";
import { handleResponse } from "../../../utils/response";

export default {
  name: "UserVip",
  data() {
    return {
      // statusMap: {
      //   1: "未生效",
      //   2: "已生效",
      //   // 3: "已作废",去除2024-06-05
      //   4: "已过期",
      // },
      // sourceMap: {
      //   1: "绑定赠送",
      //   2: "订单支付",
      //   3: "兑换码",
      // },
      sourceMap: {
        1: "绑定赠送",
        2: "订单支付",
        3: "兑换码",
        4: "订阅",
        5: "体验",
        6: "系统",
      },
      statusMap: {
        "-1": "已退款(系统标识)",
        1: "未生效",
        2: "已生效",
        3: "已作废",
        4: "已过期",
      },
      tbList: [],
      size: 10,
      page: 1,
      total: 0,
      loading: true,
      userId: "",
      vipAll: {},
    };
  },
  computed: {},
  created() {
    this.userId = this.$route.query.id;
    const vipAll = localStorage.getItem("VIP_ALL");
    if (vipAll) {
      this.vipAll = JSON.parse(vipAll);
    }
    this.init();
  },
  methods: {
    init(page = 1) {
      this.page = page;
      this.loading = true;
      userVipList({
        uid: this.userId,
        page,
        size: this.size,
      }).then((res) => {
        handleResponse(
          res,
          (data) => {
            this.tbList = data.list;
            this.total = data.count;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.init(val);
    },
  },
};
</script>
<style scoped></style>
